import { z } from "zod"
import { buildPaginationSchema } from "../shared/pagination_dtos"

export const CheckoutSessionModeEnum = {
  subscription: "subscription",
  setup: "setup",
} as const

export type CheckoutSessionMode =
  (typeof CheckoutSessionModeEnum)[keyof typeof CheckoutSessionModeEnum]

export const CreateCheckoutLinkSchema = z.object({
  priceId: z.string(),
  mode: z.literal(CheckoutSessionModeEnum.subscription),
})

export const CreateTopupsSetupSchema = z.object({
  autoTopUpPriceId: z.string(),
  monthlyLimit: z.number().optional().nullable(),
})

export const UpdateTopupsSetupSchema = z.object({
  autoTopUpPriceId: z.string().optional().nullable(),
  monthlyLimit: z.number().optional().nullable(),
})

export const BillingContactSchema = z.object({
  reason: z.enum(["Downgrade", "GetInfo"]),
  plan: z.string(),
})

export const GetCreditTransactionsSchema = buildPaginationSchema()
